import { createUseQueryOptions } from "@-/dev.improve.haniverse.lib.query-options";
import { readCountedDueUserCards, useGetDueCardCountQueryKey } from "#use-due-rows-count-query";

export function useGetDueCharactersCountQueryKey() {
  return useGetDueCardCountQueryKey("dueCharactersCount");
}

/**
 * Hook returning a `queryOptions` factory for how many characters the due review queue still
 * holds: the characters behind the cards `useDueRowsCountQueryOptions` counts, each counted once
 * however many of its cards (meaning, pronunciation) are due. Word and quiz cards are not
 * characters, and a card whose overlay hasn't synced has no known subject, so neither counts.
 */
export const [useDueCharactersCountQueryOptions] = createUseQueryOptions(
  useGetDueCharactersCountQueryKey,
  async ({ client, queryKey }) => {
    const characters = new Set<string>();
    for (const { subject } of await readCountedDueUserCards({ client, queryKey })) {
      if (subject?.kind === "grapheme") {
        characters.add(subject.text);
      }
    }
    return characters.size;
  },
);
